// import React, { useState, useEffect } from "react";
// import { Image } from "../../components/componentIndex";

// const CheckBox = ({ checkBox, name, id, onCheckBoxChange, formData, imgUrl, activeIcon, isAllergiesCheck, value, setValue, selectedPractices }) => {

//     useEffect(() => {
//         if (value) {
//             setValue(value);
//         } else if (formData && formData !== '') {
//             setValue(formData);
//         }
//     }, [formData, value, setValue]);

//     // const handleChange = () => {
//     //     if (value.includes(name)) {
//     //         // Remove the value if it's already in the array (deselect)
//     //         setValue(value?.filter(item => item !== name));
//     //     } else {
//     //         // Add the value if it's not in the array (select)
//     //         setValue([...value, name]);
//     //     }
//     //     onCheckBoxChange(name); // Sending the name (or any other value) to the parent
//     // };

//     const handleChange = () => {
//         if (Array.isArray(value) && value.includes(name)) {
//             // Remove the value if it's already in the array (deselect)
//             setValue(value.filter(item => item !== name));
//         } else {
//             // Add the value if it's not in the array (select)
//             setValue([...(Array.isArray(value) ? value : []), name]);
//         }
//         onCheckBoxChange(name); // Sending the name (or any other value) to the parent
//     };
//     return (
//         <>
//             {!isAllergiesCheck ? (
//                 <div className="form-check" onChange={handleChange}>
//                     <label className={`form-checkBox-label ${value.includes(name) ? 'checked' : ''}`} htmlFor={`${name}-${id}`} >
//                         {imgUrl && (
//                             <Image imgUrl={value.includes(name) ? activeIcon : imgUrl} altText={''} className={''} />
//                         )
//                         }
//                         <span>{name}</span>
//                         <input className={`form-checkBox-input ${value.includes(name) ? 'selected' : ''}`} type="checkbox" name={checkBox} id={`${name}-${id}`} checked={value.includes(name)} />
//                     </label>
//                 </div>
//             ) : (
                
//                 <div className="mb-3 form-check custom-checkbox" >
//                     <input type="checkbox" className="form-check-input"  id={`${name}-${id}`}  onChange={handleChange} checked={Array.isArray(value) ? value.includes(name) : false}/>
//                     <label className="form-check-label pt-2 px-2" htmlFor={`${name}-${id}`}>{name}</label>
//                 </div>
//             )}

//         </>
//     );
// };

// export default CheckBox;

import React, { useState, useEffect } from "react";
import { Image } from "../../components/componentIndex";

const CheckBox = ({ checkBox, name, id, onCheckBoxChange, formData, imgUrl, activeIcon, isAllergiesCheck, value, setValue, selectedPractices, isReferralForm }) => {

    useEffect(() => {
        if (isReferralForm) {
            if (value) {
                setValue(value);
            }else{
                setValue(false);
            }
        } else {
            if (value) {
                setValue(value);
            } else if (formData && formData !== '') {
                setValue(formData);
            }
        }

    }, [formData, value, setValue]);

    // const handleChange = () => {
    //     if (value.includes(name)) {
    //         // Remove the value if it's already in the array (deselect)
    //         setValue(value?.filter(item => item !== name));
    //     } else {
    //         // Add the value if it's not in the array (select)
    //         setValue([...value, name]);
    //     }
    //     onCheckBoxChange(name); // Sending the name (or any other value) to the parent
    // };

    const handleChange = () => {
        if (Array.isArray(value) && value.includes(name)) {
            // Remove the value if it's already in the array (deselect)
            setValue(value.filter(item => item !== name));
        } else {
            // Add the value if it's not in the array (select)
            setValue([...(Array.isArray(value) ? value : []), name]);
        }
        onCheckBoxChange(name); // Sending the name (or any other value) to the parent
    };
    const handleCheckBox = (event) => {
        const { checked } = event?.target;
        setValue(checked);
        // Handle the change based on the `checked` value
        console.log(checked);
        if(isReferralForm){
            onCheckBoxChange(checked);
        }
    }
    return (
        <>
            {!isAllergiesCheck ? (
                <div className="form-check" onChange={handleChange}>
                    <label className={`form-checkBox-label ${value.includes(name) ? 'checked' : ''}`} htmlFor={`${name}-${id}`} >
                        {imgUrl && (
                            <Image imgUrl={value.includes(name) ? activeIcon : imgUrl} altText={''} className={''} />
                        )
                        }
                        <span>{name}</span>
                        <input className={`form-checkBox-input ${value.includes(name) ? 'selected' : ''}`} type="checkbox" name={checkBox} id={`${name}-${id}`} checked={value.includes(name)} />
                    </label>
                </div>
            ) : (
                <>
                    {isReferralForm ? (
                        <div className="mb-3 form-check custom-checkbox" >
                            <input type="checkbox" className="form-check-input" id={`${name}-${id}`} onChange={(event) => handleCheckBox(event)} checked={value ? true : false} />
                            <label className="form-check-label pt-2 px-2" htmlFor={`${name}-${id}`}>{name}</label>
                        </div>
                    ) : (
                        <div className="mb-3 form-check custom-checkbox" >
                            <input type="checkbox" className="form-check-input" id={`${name}-${id}`} onChange={handleChange} checked={Array.isArray(value) ? value.includes(name) : false} />
                            <label className="form-check-label pt-2 px-2" htmlFor={`${name}-${id}`}>{name}</label>
                        </div>
                    )}
                </>
            )}

        </>
    );
};

export default CheckBox;